import { app, initializeOdinApp } from './firebaseOdinInit'
import {
  getAuth,
  signInWithCustomToken,
  setPersistence,
  browserSessionPersistence,
  signOut,
  onIdTokenChanged,
  User
} from 'firebase/auth'
import type { FirestoreError } from 'firebase/firestore'

initializeOdinApp()
const auth = getAuth()

export const firebaseSignInWithCustomToken = async (token: string, errorHandler: (error: any) => void) => {
  try {
    await setPersistence(auth, browserSessionPersistence)
    const userCredential = await signInWithCustomToken(auth, token)
    return userCredential
  } catch (error) {
    const errorCode = error.code
    const errorMessage = error.message
    console.error(errorCode, errorMessage)
    errorHandler(error)
    return null
  }
}
export const firebaseSignOut = async () => {
  try {
    await signOut(auth)
  } catch (error) {
    return error
  }
}
export const firebaseSetListener = (
  path: string,
  id: string | null | undefined,
  listener: (snapshot: any) => void,
  onError?: (error: FirestoreError) => void,
  includeMetadataChanges = false
) => {
  const options = { includeMetadataChanges }
  let unsubscribe: (() => void) | undefined
  let cancelled = false

  import('firebase/firestore')
    .then(({ getFirestore, onSnapshot, collection, doc }) => {
      if (cancelled) return
      const db = getFirestore(app)
      unsubscribe = id
        ? onSnapshot(doc(db, path, id), options, listener, onError)
        : onSnapshot(collection(db, path), options, listener, onError)
    })
    .catch((error) => onError?.(error))

  return () => {
    cancelled = true
    unsubscribe?.()
  }
}

export const getFirebaseIdTokenResult = async () => {
  const user = auth.currentUser
  if (!user) {
    return null
  }
  return user.getIdTokenResult()
}

export const onFirebaseIdTokenChanged = (callback: (user: User | null) => void) => {
  return onIdTokenChanged(auth, callback)
}
